// Generated by scripts/build-storefront-lining-images.cjs from the existing WebP export manifest.
// Local preview use does not change individual image approvals or authorize a live upload.
(() => {
  const entries = {
  "18df4b29f7c9": {
    "sourceName": "caiman3_black_matte_ws_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-18df4b29f7c9/v1/lining-18df4b29f7c9-v1-corrected.webp?v=7b3ac6fa02d6",
      "alt": "Caiman Series 3 | Noir Mat w/ Contrast Stitch — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "c4e3e2c549d9": {
    "sourceName": "caiman3_cognac_glazed_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-c4e3e2c549d9/v2/lining-cognac-v2-corrected.webp?v=597a2163ea80",
      "alt": "Caiman Series 3 | Cognac Glacé — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "88e8b5a26b8d": {
    "sourceName": "caiman3_windsor_matte_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-88e8b5a26b8d/v1/lining-88e8b5a26b8d-v1-corrected.webp?v=798ff2caf1d4",
      "alt": "Caiman Series 3 | Windsor Mat — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "d72ee5e7ea21": {
    "sourceName": "caiman3_navy_matte_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-d72ee5e7ea21/v1/lining-d72ee5e7ea21-v1-corrected.webp?v=ee8fcec52e24",
      "alt": "Caiman Series 3 | Bleu Marine Mat — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "009ccacf42a3": {
    "sourceName": "caiman3_white_glazed_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-009ccacf42a3/v1/lining-009ccacf42a3-v1-corrected.webp?v=3c48de5bc4fb",
      "alt": "Caiman Series 3 | Blanc Neige — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "8f7dab0c126e": {
    "sourceName": "caiman3_rose_satin_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-8f7dab0c126e/v1/lining-8f7dab0c126e-v1-corrected.webp?v=8f125a72c14d",
      "alt": "Caiman Series 3 | Rose Satin — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "916f2cb99307": {
    "sourceName": "caiman3_sky_glazed_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-916f2cb99307/v1/lining-916f2cb99307-v1-corrected.webp?v=b3d1b7d41ac8",
      "alt": "Caiman Series 3 | Bleu Ciel — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "42799e9ab2c3": {
    "sourceName": "caiman3_navy_patent_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-42799e9ab2c3/v1/lining-42799e9ab2c3-v1-corrected.webp?v=b4bfa60a4133",
      "alt": "Caiman Series 3 | Bleu Marine — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "fd990f1d4f5b": {
    "sourceName": "caiman3_navy_matte_ws_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-fd990f1d4f5b/v1/lining-fd990f1d4f5b-v1-corrected.webp?v=c41be5f13f51",
      "alt": "Caiman Series 3 | Bleu Marine Mat w/ Contrast Stitch — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "27248bec8c48": {
    "sourceName": "caiman3_bourgogne_glazed_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-27248bec8c48/v1/lining-27248bec8c48-v1-corrected.webp?v=c51c481bfafb",
      "alt": "Caiman Series 3 | Bourgogne Glacé — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "376cac68ff08": {
    "sourceName": "caiman3_marron_glazed_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-376cac68ff08/v1/lining-376cac68ff08-v1-corrected.webp?v=99e6b544a622",
      "alt": "Caiman Series 3 | Marron Glacé — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "eabadca894e8": {
    "sourceName": "caiman3_marron_matte_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-eabadca894e8/v1/lining-eabadca894e8-v1-corrected.webp?v=076a8705d4e9",
      "alt": "Caiman Series 3 | Marron Mat — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "3c306a04b43a": {
    "sourceName": "caiman3_marron_patent_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-3c306a04b43a/v1/lining-3c306a04b43a-v1-corrected.webp?v=46977ddb8243",
      "alt": "Caiman Series 3 | Marron Verni — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "7d6483e456c8": {
    "sourceName": "caiman3_black_glazed_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-7d6483e456c8/v1/lining-7d6483e456c8-v1-corrected.webp?v=0ceed9438162",
      "alt": "Caiman Series 3 | Noir Glacé — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "f8c78dd5aad0": {
    "sourceName": "caiman3_black_matte_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-f8c78dd5aad0/v1/lining-f8c78dd5aad0-v1-corrected.webp?v=795c72a02978",
      "alt": "Caiman Series 3 | Noir Mat — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "08ecc8d12a97": {
    "sourceName": "caiman3_black_patent_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-08ecc8d12a97/v1/lining-08ecc8d12a97-v1-corrected.webp?v=b87ad2a5d5ce",
      "alt": "Caiman Series 3 | Noir Verni — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "840955d3b07a": {
    "sourceName": "caiman3_rouge_patent_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-840955d3b07a/v1/lining-840955d3b07a-v1-corrected.webp?v=01c7a243aed2",
      "alt": "Caiman Series 3 | Rouge Verni — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "946a9e68f860": {
    "sourceName": "caiman3_windsor_matte_ws_2420_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-946a9e68f860/v1/lining-946a9e68f860-v1-corrected.webp?v=7bedd2ba84ae",
      "alt": "Caiman Series 3 | Windsor Mat w/ Contrast Stitch — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  },
  "d9c0c8906a5b": {
    "sourceName": "caiman3_windsor_patent_2016_applewatch_closeup.webp",
    "image": {
      "src": "/storefront-assets/work-in-progress/lining-d9c0c8906a5b/v1/lining-d9c0c8906a5b-v1-corrected.webp?v=142baf661644",
      "alt": "Caiman Series 3 | Windsor Verni — calfskin lining with Cuir de veau véritable lettering",
      "width": 1000,
      "height": 1250
    }
  }
};
  globalThis.LongvadonLiningImages = {
    gallery(groupId, images) {
      const entry = entries[groupId];
      if (!entry) return images;
      return images.map(image => {
        const name = new URL(image.src, 'https://longvadon.com').pathname.split('/').pop().replace(/_[0-9a-f-]{36}(?=\.)/i, '');
        return name === entry.sourceName ? {...image, ...entry.image, src:globalThis.LongvadonRedesign.asset(entry.image.src)} : image;
      });
    },
  };
})();
